import { PrivacyPolicyAggregate } from 'src/app/models/privacy-policy/privacy-policy-aggregate';
import { PrivacyPolicyUrl } from 'src/app/models/privacy-policy/privacy-policy-url';
import { PrivacyPolicyVersion } from 'src/app/models/privacy-policy/privacy-policy-version';

export class PrivacyPolicyViewModel {
  readonly version: PrivacyPolicyVersion;
  readonly url: PrivacyPolicyUrl;
  constructor(private readonly params: PrivacyPolicyAggregate) {
    this.version = params.version;
    this.url = params.url;
  }
}
